import { createSelector } from 'reselect';
import { RootState } from './typeDefs';

export const reportsCenterStateSelector = (state: RootState) =>
  state.reportsCenter;

export const generateReportStateSelector = (state) => state.generateReport;

/**
 * Selects the lps that selected in the dropdown.
 */
export const lpSelectedSelector = createSelector(
  reportsCenterStateSelector,
  ({ lpSelected }) => lpSelected
);

export const termReportConfigsSelector = createSelector(
  reportsCenterStateSelector,
  (reportsCenterState) => {
    return reportsCenterState?.termReportConfigs ?? [];
  }
);

export const getTermReportConfigsErrorSelector = createSelector(
  reportsCenterStateSelector,
  ({ getTermReportConfigsError }) => getTermReportConfigsError
);

export const reportsListSelector = createSelector(
  reportsCenterStateSelector,
  ({ reportsList }) => reportsList
);

export const reportsListTotalRecordsSelector = createSelector(
  reportsCenterStateSelector,
  (reportsCenterState) => reportsCenterState?.reportsListTotalRecords ?? []
);

export const searchReportsPageSizeSelector = createSelector(
  reportsCenterStateSelector,
  ({ searchReportsPageSize }) => searchReportsPageSize
);

export const bulkFilesPartsUploadSelector = createSelector(
  reportsCenterStateSelector,
  ({ bulkFilesPartsUpload }) => bulkFilesPartsUpload
);

export const isTriggerSearchReportSelector = createSelector(
  reportsCenterStateSelector,
  ({ isTriggerSearchReport }) => isTriggerSearchReport
);

export const currentFolderPathSelector = createSelector(
  reportsCenterStateSelector,
  ({ currentFolderPath }) => currentFolderPath
);

export const currentPageSelector = createSelector(
  reportsCenterStateSelector,
  ({ currentPage }) => currentPage
);

export const selectedReportsSelector = createSelector(
  reportsCenterStateSelector,
  ({ selectedReports }) => selectedReports
);

export const sortCriteriaSelector = createSelector(
  reportsCenterStateSelector,
  ({ sortCriteria }) => sortCriteria
);

export const getPresignedUrl = createSelector(
  generateReportStateSelector,
  ({ presignedURL }) => presignedURL
);

export const selectDDUList = createSelector(
  generateReportStateSelector,
  ({ dduList }) => dduList
);

export const getReportIdGenerated = createSelector(
  generateReportStateSelector,
  ({ reportValue }) => reportValue
);

export const selectIsGenerateReportTriggered = createSelector(
  generateReportStateSelector,
  ({ isTriggerGenerateReport }) => isTriggerGenerateReport
);

export const getPresignedDownloadUrl = createSelector(
  reportsCenterStateSelector,
  ({ downloadReportPresignedURL }) => downloadReportPresignedURL
);

export const getCSVData = createSelector(
  generateReportStateSelector,
  ({ csvData }) => csvData
);

export const isTriggerFetchDataFromPresignedURL = createSelector(
  generateReportStateSelector,
  ({ isTriggerFetchDataFromPresignedURL }) => isTriggerFetchDataFromPresignedURL
);

export const reportDetailsSelector = createSelector(
  reportsCenterStateSelector,
  ({ reportDetails }) => reportDetails
);

export const filterSheetOpenSelector = createSelector(
  reportsCenterStateSelector,
  ({ filterSheetOpen }) => filterSheetOpen
);

export const filtersSelector = createSelector(
  reportsCenterStateSelector,
  ({ filters }) => filters
);

export const isGetReportDetailsPollingSelector = createSelector(
  reportsCenterStateSelector,
  ({ isGetReportDetailsPolling }) => isGetReportDetailsPolling
);
